import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgLinkedinShare = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2ZM9.68 16.82H7.85v-6.71h1.83v6.71Zm-.91-7.48c-.59 0-1.07-.48-1.07-1.08 0-.6.48-1.08 1.07-1.08.59 0 1.07.48 1.07 1.08 0 .6-.48 1.08-1.07 1.08ZM17 16.82h-1.83V13.4c0-2.05-2.44-1.9-2.44 0v3.42H10.9v-6.71h1.83v1.08C13.58 9.61 17 9.5 17 12.7v4.12Z",
    clipRule: "evenodd"
  })
});
export default SvgLinkedinShare;